import * as Yup from 'yup';

import { VALIDATOR } from '../validator';

export const inviteAdminSchema = Yup.object({
  email: VALIDATOR.email,
  phone: VALIDATOR.phone,
  firstName: VALIDATOR.name.notRequired(),
  lastName: VALIDATOR.name.notRequired(),
});
